import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  fetchOfflineTransactionRequest,
  fetchOfflineTransactionSuccess,
  fetchOfflineTransactionFailure,
  verifyOfflineTransactionRequest,
  verifyOfflineTransactionSuccess,
  verifyOfflineTransactionFailure,
  cancelOfflineTransactionRequest,
  cancelOfflineTransactionSuccess,
  cancelOfflineTransactionFailure,
} from "./OfflineTSlice";

function* fetchOfflineTransactionSaga(action) {
  try {
    const { start = 0, limit = 5, search = "",startDate = "", endDate = "" } = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/api/v1/transactions/getOfflinetransaction?start=${start}&limit=${limit}&search=${encodeURIComponent(
          search
        )}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`
      )
    );

    const resData = response.data;

    if (resData.success) {
      const formattedData = resData.data.orders.map((item) => ({
        ...item,
        MetalName: `${item.order?.bullion?.metalName}-${item.order?.bullion?.karat}k-${item.order?.bullion?.purity}`,
        customerName: `${item.customer?.firstName} ${item.customer?.lastName}`,
      }));

      yield put(
        fetchOfflineTransactionSuccess({
          orders: formattedData,
          total: resData.data.total,
          message: resData.message,
        })
      );

      toast.success(
        resData.message || "Offline transactions fetched successfully"
      );
    } else {
      yield put(fetchOfflineTransactionFailure(resData.message));
      toast.error(resData.message || "Failed to fetch offline transactions");
    }
  } catch (error) {
    yield put(fetchOfflineTransactionFailure(error.message));
    toast.error(`Error fetching offline transactions: ${error.message}`);
  }
}

function* verifyOfflineTransactionSaga(action) {
  try {
    const { id, branchCode } = action.payload;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/verifyMetalOffline`,
        { id, branchCode }
      )
    );

    const resData = response.data;

    if (resData.success) {
      yield put(verifyOfflineTransactionSuccess(resData));
      toast.success(resData.message || "Transaction verified successfully");

      yield put(
        fetchOfflineTransactionRequest({ start: 0, limit: 5, search: "" })
      );
    } else {
      yield put(verifyOfflineTransactionFailure(resData.message));
      toast.error(resData.message || "Failed to verify transaction");
    }
  } catch (error) {
    yield put(verifyOfflineTransactionFailure(error.message));
    toast.error(`Error verifying transaction: ${error.message}`);
  }
}

function* cancelOfflineTransactionSaga(action) {
  try {
    const { id, remark } = action.payload;

    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/cancelOfflinetransaction`,
        { id, remark }
      )
    );

    const resData = response.data;

    if (resData.success) {
      yield put(cancelOfflineTransactionSuccess(resData));
      toast.success(resData.message || "Transaction cancelled successfully");

      // optional: refresh the list after cancel
      yield put(
        fetchOfflineTransactionRequest({ start: 0, limit: 5, search: "" })
      );
    } else {
      yield put(cancelOfflineTransactionFailure(resData.message));
      toast.error(resData.message || "Failed to cancel transaction");
    }
  } catch (error) {
    yield put(cancelOfflineTransactionFailure(error.message));
    toast.error(`Error cancelling transaction: ${error.message}`);
  }
}

export function* watchOfflineTransactionSaga() {
  yield takeLatest(
    fetchOfflineTransactionRequest.type,
    fetchOfflineTransactionSaga
  );
  yield takeLatest(
    verifyOfflineTransactionRequest.type,
    verifyOfflineTransactionSaga
  );
  yield takeLatest(
    cancelOfflineTransactionRequest.type,
    cancelOfflineTransactionSaga
  );
}
